import { render, staticRenderFns } from "./PageCourseVideo.vue?vue&type=template&id=b5219422&"
import script from "./PageCourseVideo.vue?vue&type=script&lang=js&"
export * from "./PageCourseVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports